<template>
  <div class="page loader">

    <div v-if="auth || $route.meta.public" class="bg-custom">

      <app-header v-if="(auth || $route.meta.public) && $route.meta.unbranded != true" @logout="logout" class="bg-gradient" />
      <section :class="['bg-white min-h-custom',
        $route.meta.unbranded != true ? 'rounded-t-3xl pb-10' : ''  
        ]">
        <app-sidebar v-if="auth" ref="sideBarComp" @addParentMenu="addMenu($event)" />
        <router-view />
      </section>
      <app-footer v-if="(auth || $route.meta.public) && $route.meta.unbranded != true" />
    </div>
  </div>
</template>

<script>
import esMessages from '@/assets/lang/es.json';
import { locale, loadMessages } from "devextreme/localization";
import AppHeader from "@/components/layout/AppHeader"
import AppFooter from "@/components/layout/AppFooter"
import AppSidebar from "@/components/layout/AppSidebar"

export default {
  components: {
    AppHeader,
    AppSidebar,
    AppFooter
  },
  data() {
    return {
      auth: false
    }
  },
  created() {
    loadMessages(esMessages);
    locale("es-MX");
  },
  methods: {
    logout() {
      this.auth = false
      localStorage.clear()
      delete this.$http.defaults.headers.common['Authorization']
      console.log(this.$route)
      this.$route.path != '/' ? this.$router.push('/') : ''
    }
  }
};
</script>
<style scoped>
.bg-gradient{
    background: var(--brand-header-gradient);
}
.bg-custom{background: var(--brand-page-background);}
.min-h-custom{
  min-height: calc(100vh - 85px);
  min-height: -o-calc(100vh - 85px); /* opera */
  min-height: -webkit-calc(100vh - 85px); /* google, safari */
  min-height: -moz-calc(100vh - 85px); /* firefox */
}
</style>
